<template>
    <section class="the-document-entry">
        <header class="header d-flex align-center">
            <i class="header__icon"></i>
            <span class="header__zh-title">{{entryType }}</span>
            <!-- <span class="header__en-title">/ {{ entry.englishName }}</span> -->
        </header>

        <div class="shelf">
            <the-document-shelf
                v-for="shelf in entry"
                :key="shelf.typeName"
                class="shelf__item"
                :shelf="shelf"
            ></the-document-shelf>
        </div>
    </section>
</template>

<script>
import TheDocumentShelf from './the-document-shelf';
export default {
    name: 'TheDocumentEntry',
    components: { TheDocumentShelf },
    props: {
        entryType: {
            type: String,
            default: ""
        },
        entry: {
            type: Array,
            default: () => ({})
        }
    }
};
</script>

<style lang="scss" scoped>
.the-document-entry {
    padding-bottom: 80px;
    margin-bottom: 80px;
    border-bottom: 1px dashed #e1e1e1;

    &:last-child {
        padding-bottom: 0;
        margin-bottom: 0;
        border-bottom: 0;
    }
}

.header {
    margin-bottom: 40px;
    &__icon {
        display: block;
        width: 36px;
        height: 36px;
        margin-right: 9px;
        background: url('../../assets/icon.png');
        background-size: cover;
    }
    &__zh-title {
        font-size: 26px;
        letter-spacing: 1px;
        color: #333;
        margin-right: 14px;
        height: 37px;
        font-weight: 500;
    }
    &__en-title {
        height: 42px;
        color: #bbb;
        font-size: 30px;
        font-weight: 400;
        letter-spacing: 1px;
    }
}

.shelf {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: (1200px - 270px * 4)/3;
    grid-row-gap: 40px;
}
</style>
